import {useGetCompetitorIqWebsites} from './use-get-competitor-iq-websites';

export const useIsCompetitorIqConfigured = (): {
    isDomainConfigured: boolean;
    areCompetitorsConfigured: boolean;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const {website, competitors, isLoading, error} = useGetCompetitorIqWebsites();
    const isDomainConfigured = Boolean(website);
    const areCompetitorsConfigured = Boolean(competitors && competitors.length > 0);

    return {
        isLoading,
        error,
        isDomainConfigured,
        areCompetitorsConfigured,
    };
};
